import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IUpdatePaymentItemsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/FilterTripAction";


class UpdatePaymentItemsAction extends BaseAction<any[], IUpdatePaymentItemsActionParams> {

    override async run(): Promise<any[]> {
        const outBoundPassengerDetails: any = []
        try {
            const { atomKey, outBoundPassengerPriceList } = this.params!
            let allOutBoundInfantCount = 0
            let allOutBoundChildrenCount = 0
            let allOutBoundAdultCount = 0
            let allStudentCount = 0
            let allOutBoundSeniorCitizenCount = 0
            let allWheelchairCount = 0
            let allReducedMobilityCount = 0
            outBoundPassengerPriceList.forEach((p: any) => {
                if (p.pType === "Infant") allOutBoundInfantCount++
                if (p.pType === "Children") allOutBoundChildrenCount++
                if (p.pType === "Student") allStudentCount++
                if (p.pType === "Adult") allOutBoundAdultCount++
                if (p.pType === "Senior Citizen") allOutBoundSeniorCitizenCount++
                if (p.pType === "Wheelchair") allWheelchairCount++
                if (p.pType === "People with Reduced Mobility") allReducedMobilityCount++
            })
            // if (allOutBoundAdultCount > 0) outBoundPassengerDetails.push({
            //     description: `${allOutBoundAdultCount} Adult`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Adult")?.pValue || 0) * allOutBoundAdultCount
            // })
            // if (allOutBoundChildrenCount > 0) outBoundPassengerDetails.push({
            //     description: `${allOutBoundChildrenCount} Children`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Children")?.pValue || 0) * allOutBoundChildrenCount
            // })
            // if (allOutBoundInfantCount > 0) outBoundPassengerDetails.push({
            //     description: `${allOutBoundInfantCount} Infant`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Infant")?.pValue || 0) * allOutBoundInfantCount
            // })
            // if (allOutBoundSeniorCitizenCount > 0) outBoundPassengerDetails.push({
            //     description: `${allOutBoundSeniorCitizenCount} Senior Citizen (UAE)`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Senior Citizen")?.pValue || 0) * allOutBoundSeniorCitizenCount
            // })
            // if (allStudentCount > 0) outBoundPassengerDetails.push({
            //     description: `${allStudentCount} Student`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Student")?.pValue || 0) * allStudentCount
            // })
            // if (allReducedMobilityCount > 0) outBoundPassengerDetails.push({
            //     description: `${allReducedMobilityCount} People with Reduced Mobility`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "People with Reduced Mobility")?.pValue || 0) * allReducedMobilityCount
            // })
            // if (allWheelchairCount > 0) outBoundPassengerDetails.push({
            //     description: `${allWheelchairCount} Wheelchair`,
            //     amount: (outBoundPassengerPriceList.find((d: any) => d.pType === "Wheelchair")?.pValue || 0) * allWheelchairCount
            // })

            const addPassengerDetail = (count: number, pType: string, label: string) => {
                if (count > 0) {
                    const totalAmount = outBoundPassengerPriceList
                        .filter((d: any) => d.pType === pType)
                        .reduce((sum: number, d: any) => sum + (d.pValue || 0), 0);
        
                    outBoundPassengerDetails.push({
                        description: `${count} ${label}`,
                        amount: totalAmount
                    });
                }
            };
        
            // Use common function to handle all types
            addPassengerDetail(allOutBoundAdultCount, "Adult", "Adult");
            addPassengerDetail(allOutBoundChildrenCount, "Children", "Children");
            addPassengerDetail(allOutBoundInfantCount, "Infant", "Infant");
            addPassengerDetail(allOutBoundSeniorCitizenCount, "Senior Citizen", "Senior Citizen (UAE)");
            addPassengerDetail(allStudentCount, "Student", "Student");
            addPassengerDetail(allReducedMobilityCount, "People with Reduced Mobility", "People with Reduced Mobility");
            addPassengerDetail(allWheelchairCount, "Wheelchair", "Wheelchair");

            if (atomKey === "paymentOutboundAtom")
                updateRecoilState(atomKey, outBoundPassengerDetails)
            if (atomKey === "paymentOutboundRefundAtom")
                updateRecoilState(atomKey, outBoundPassengerDetails)
            if (atomKey === "paymentInboundAtom")
                updateRecoilState(atomKey, outBoundPassengerDetails)
            if (atomKey === "paymentInboundRefundAtom")
                updateRecoilState(atomKey, outBoundPassengerDetails)
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        } finally {
            return outBoundPassengerDetails
        }
    }
}

export const updatePaymentItemsAction = new UpdatePaymentItemsAction()